import React from 'react';
import { ApiKeyProvider } from './contexts/ApiKeyContext';
import Header from './components/Header';
import ApiKeySection from './components/ApiKeySection';
import TopicPredictionForm from './components/TopicPredictionForm';
import './styles/App.css';

function App() {
  return (
    <ApiKeyProvider>
      <div className="app">
        <Header />
        <main className="main-content">
          <ApiKeySection />
          <TopicPredictionForm />
        </main>
      </div>
    </ApiKeyProvider>
  );
}

export default App;
